export const memory: Record<string, any> = {}
